export default __webpack_public_path__ + "static/media/shake2.bf3882c0.jpg";